export const emptyFroalaEditor = '<div style="font-size: 14px;"></div>';

export const EDITORSETTINGS = {
  key: 'FSC2H-9H1A9B4A2A3D2rXYf1VPUGRHYZNRJb2JVOOe1HAb2zA3B2A1B1F4E1F1A10A1C7==',
  toolbarButtons: {
    moreText: {
      buttons: [
        'bold',
        'italic',
        'underline',
        'paragraphFormat',
        'clearFormatting',
        'strikeThrough',
        'subscript',
        'superscript',
        'textColor',
        'backgroundColor'
      ],
      buttonsVisible: 5
    },
    moreParagraph: {
      buttons: [
        'formatUL',
        'formatOLSimple',
        'alignLeft',
        'alignCenter',
        'alignRight',
        'alignJustify',
        'indent',
        'outdent',
        'lineHeight'
      ],
      buttonsVisible: 4
    },
    moreRich: {
      buttons: ['insertTable', 'insertImage', 'insertLink', 'insertHR'],
      buttonsVisible: 1
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'spellChecker', 'fullscreen', 'html', 'clear'],
      buttonsVisible: 3,
      align: 'right'
    }
  },
  toolbarButtonsSM: {
    moreText: {
      buttons: [
        'bold',
        'italic',
        'underline',
        'paragraphFormat',
        'clearFormatting',
        'strikeThrough',
        'subscript',
        'superscript',
        'textColor',
        'backgroundColor'
      ],
      buttonsVisible: 5
    },
    moreParagraph: {
      buttons: [
        'formatUL',
        'formatOLSimple',
        'alignLeft',
        'alignCenter',
        'alignRight',
        'alignJustify',
        'indent',
        'outdent',
        'lineHeight'
      ],
      buttonsVisible: 4
    },
    moreRich: {
      buttons: ['insertTable', 'insertImage', 'insertLink', 'insertHR'],
      buttonsVisible: 0
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'spellChecker', 'fullscreen', 'html', 'clear'],
      buttonsVisible: 2,
      align: 'right'
    }
  },
  toolbarButtonsXS: {
    moreText: {
      buttons: [
        'bold',
        'italic',
        'underline',
        'paragraphFormat',
        'clearFormatting',
        'strikeThrough',
        'subscript',
        'superscript',
        'textColor',
        'backgroundColor'
      ],
      buttonsVisible: 0
    },
    moreParagraph: {
      buttons: [
        'formatUL',
        'formatOLSimple',
        'alignLeft',
        'alignCenter',
        'alignRight',
        'alignJustify',
        'indent',
        'outdent',
        'lineHeight'
      ],
      buttonsVisible: 0
    },
    moreRich: {
      buttons: ['insertTable', 'insertImage', 'insertLink', 'insertHR'],
      buttonsVisible: 0
    },
    moreMisc: {
      buttons: ['undo', 'redo', 'spellChecker', 'fullscreen', 'html', 'clear'],
      buttonsVisible: 2,
      align: 'right'
    }
  },
  dragInline: false,
  tableResizer: false,
  tableInsertButtons: ['tableBack'],
  linkInsertButtons: ['linkBack'],
  //TODO: UNCOMMENT THIS
  // linkAlwaysBlank: true,
  linkEditButtons: ['linkOpen', 'linkEdit', 'linkRemove'],
  tableEditButtons: [
    'tableHeader',
    '|',
    'tableRows',
    'tableColumns',
    'tableCells',
    'tableStyle',
    '-',
    'tableCellBackground',
    'tableCellVerticalAlign',
    'tableCellHorizontalAlign',
    'tableRemove'
  ],
  tableStyles: {
    'fr-dashed-borders': 'fr-dashed-borders',
    'fr-alternate-rows': 'fr-alternate-rows',
    'fr-no-borders': 'fr-no-borders'
  },
  lineHeights: {
    ' 1': '1',
    ' 1.5': '',
    ' 2': '2',
    ' 2.5': '2.5',
    ' 3': '3'
  },
  paragraphFormat: {
    N: 'Normal',
    H1: 'Heading 1',
    H2: 'Heading 2',
    H3: 'Heading 3',
    H4: 'Heading 4'
  },
  wordPasteModal: false,
  quickInsertEnabled: false,
  colorsHEXInput: false,
  colorsButtons: ['colorsBack', '|', '-'],
  attribution: false,
  charCounterCount: true,
  language: 'nl',
  placeholderText: false,
  tabSpaces: 4,
  heightMin: 200,
  zIndex: 1200,
  htmlUntouched: true,
  imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif'],
  imageInsertButtons: ['imageUpload', 'imageByURL'],
  imageDefaultWidth: 600,
  imageDefaultAlign: 'left',
  allowScript: false,
  crossDomain: false,
  imageAddNewLine: true,
  imageMove: true,
  imageOutputSize: true,
  imageEditButtons: [
    'imageAlt',
    'imageSize',
    'imageReplace',
    'imageAlign',
    'imageDisplay',
    '-',
    'imageLink',
    'linkOpen',
    'linkEdit',
    'linkRemove',
    '|',
    'imageRemove'
  ],
  htmlExecuteScripts: false,
  htmlAllowedTags: [
    'div',
    'span',
    'hr',
    'p',
    'em',
    'a',
    'strong',
    'u',
    's',
    'br',
    'ul',
    'ol',
    'li',
    'h1',
    'h2',
    'h3',
    'h4',
    'table',
    'th',
    'tr',
    'td',
    'thead',
    'tbody',
    'sub',
    'sup',
    'img'
  ],
  htmlAllowedStyleProps: [
    'align',
    'background',
    'color',
    'width',
    'text-align',
    'vertical-align',
    'background-color',
    'padding',
    'margin',
    'height',
    'margin-top',
    'margin-left',
    'margin-right',
    'margin-bottom',
    'text-decoration',
    'font-weight',
    'font-style',
    'text-indent',
    'border',
    'border-.*',
    'width',
    'height'
  ],
  htmlDoNotWrapTags: ['script', 'style', 'img'],
  htmlRemoveTags: ['script', 'style', 'base', 'link'],
  pasteAllowedStyleProps: [],
  wordAllowedStyleProps: [],
  htmlAllowedAttrs: [
    'action',
    'align',
    'allowfullscreen',
    'allowtransparency',
    'alt',
    'aria-.*',
    'autocomplete',
    'autofocus',
    'background',
    'bgcolor',
    'border',
    'cellpadding',
    'cellspacing',
    'class',
    'color',
    'cols',
    'colspan',
    'content',
    'data',
    'data-.*',
    'datetime',
    'default',
    'height',
    'hidden',
    'href',
    'icon',
    'id',
    'label',
    'list',
    'low',
    'max',
    'maxlength',
    'media',
    'min',
    'mozallowfullscreen',
    'multiple',
    'name',
    'open',
    'placeholder',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rows',
    'rowspan',
    'scrolling',
    'selected',
    'shape',
    'size',
    'sizes',
    'span',
    'src',
    'start',
    'summary',
    'spellcheck',
    'style',
    'tabindex',
    'target',
    'title',
    'type',
    'value',
    'valign',
    'webkitallowfullscreen',
    'width',
    'wrap'
  ],
  htmlAllowedEmptyTags: ['.fa', '.fr-inner', 'hr'],
  requestHeaders: {
    Authorization: ''
  }
};
